module.exports = __webpack_public_path__ + "img/banner_notice.64471b08.png";